(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const reelContainer = document.getElementById("native-reels");
  if (!reelContainer) return;

  const videos = reelContainer.querySelectorAll("video");

  /* 悬停自动播放 + 暂停其他视频 */
  videos.forEach((video, index) => {
    video.addEventListener("mouseenter", () => {
      videos.forEach((v, i) => {
        if (i !== index && !v.paused) v.pause();
      });
      video.play();
    });
  });

  /* 点击播放/暂停 + 暂停其他视频 */
  videos.forEach((video, index) => {
    video.addEventListener("click", () => {
      videos.forEach((v, i) => {
        if (i !== index && !v.paused) v.pause();
      });

      if (video.paused) video.play();
      else video.pause();
    });
  });

  /* 桌面端：自动居中第一个视频 */
  const cards = reelContainer.querySelectorAll(".video-card");
  const centerFirstCard = () => {
    if (window.innerWidth <= 768) return;
    const first = cards[0];
    if (!first) return;

    const containerWidth = reelContainer.offsetWidth;
    const cardCenter = first.offsetLeft + first.offsetWidth / 2;

    reelContainer.scrollTo({
      left: cardCenter - containerWidth / 2,
      behavior: "smooth"
    });
  };

  requestAnimationFrame(centerFirstCard);
});



  } catch(e) { console.error(e); }
})();
})();
